import React from 'react';

import { DialogoCreateEdit } from '../../Components/modulo-gerencial-dialogos';
import { TextInput } from '../../Components/modulo-gerencial-formularios';

const initialValues = {
  nome: '',
};

const validadores = {
  nome: (value) => {
    if (!value || value.length < 1) return 'Este campo é obrigatório';
    if (value.length > 80) return 'Não pode ser maior que 80 caracteres';
    return '';
  },
};

const transformGetDados = (dados) => ({
  nome: dados.nome,
});

const transformSalvar = (dados) => ({
  nome: dados.nome,
});

function Form() {
  return (
    <div>
      <TextInput name="nome" fullWidth label="Descrição" autoFocus />
    </div>
  );
}

const Dialogo = ({ onClose, open, id, isDialogoConfirmacaoActions }) => (
  <DialogoCreateEdit
    open={open}
    id={id}
    initialValues={initialValues}
    validators={validadores}
    resource="equipamentos_freezer"
    titleCreate="Novo Freezer"
    titleUpdate="Editar Freezer"
    onClose={onClose}
    transformGetDados={transformGetDados}
    transformSalvar={transformSalvar}
    isCloseTitle
    isDialogoConfirmacaoActions={isDialogoConfirmacaoActions}
  >
    <Form />
  </DialogoCreateEdit>
);

export default Dialogo;
